import { t } from 'i18next'
import { Chart } from 'primereact/chart'
import React, { useState } from 'react'
import { useAppSelector } from '../../../../redux/hooks'

export const PeopleInSystemStatistic = () => {
  const apprentices = useAppSelector((state) => state.apprentices)
  const employees = useAppSelector((state) => state.employees)
  const persons = useAppSelector((state) => state.persons)
  const [totalLength] = useState<number>(
    apprentices.length + employees.length + persons.length
  )

  const [peopleInSystemChartData] = useState({
    labels: [
      t<string>('core.apprentices'),
      t<string>('core.employees'),
      t<string>('core.persons'),
    ],
    datasets: [
      {
        data: [apprentices.length, employees.length, persons.length],
        backgroundColor: ['#7BAFDA', '#006699', 'rgb(135, 136, 138)'],
        hoverBackgroundColor: ['#8fcfff', '#008fd7', 'rgb(213,213,213)'],
      },
    ],
  })

  return (
    <div className={'col card-hover'}>
      <h4 className={'statistic-text w-full'}>
        <>
          {t<string>('core.statistic.count_people_in_system')} ({totalLength})
        </>
      </h4>
      <div className={'grid justify-content-center align-items-center'}>
        <Chart
          className={'statistic-chart'}
          height={'240px'}
          width={'240px'}
          type={'doughnut'}
          data={peopleInSystemChartData}
        />
      </div>
    </div>
  )
}